import React, { useState, useEffect, useContext, useRef } from "react";
import "emoji-mart/css/emoji-mart.css";
import { useParams } from "react-router-dom";
import { Picker } from "emoji-mart";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import TextFormatIcon from '@material-ui/icons/TextFormat';
import DeleteIcon from "@material-ui/icons/Delete";
import {
  FormControlLabel,
  Hidden,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from "@material-ui/core";
import { AttachFile, Cancel, CheckCircleOutline, Clear, HighlightOff, Mic, Mood, Send, TextFormat, RecordVoiceOver } from "@material-ui/icons";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

// Eliminamos mic-recorder-to-mp3 y Lame porque causan errores en Vite
// Implementamos una clase nativa basada en MediaRecorder que genera webm/ogg (soportado por WhatsApp)
class NativeMicRecorder {
  constructor() {
    this.mediaRecorder = null;
    this.audioChunks = [];
    this.stream = null;
  }

  async start() {
    this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.mediaRecorder = new MediaRecorder(this.stream);
    this.audioChunks = [];

    this.mediaRecorder.addEventListener("dataavailable", event => {
      this.audioChunks.push(event.data);
    });

    this.mediaRecorder.start();
  }

  stop() {
    return {
      getMp3: () => new Promise(resolve => {
        this.mediaRecorder.addEventListener("stop", () => {
          // Generamos un blob OGG/WEBM que es el estándar actual y compatible con el backend
          const audioBlob = new Blob(this.audioChunks, { type: "audio/webm;codecs=opus" });
          resolve([this.audioChunks, audioBlob]);
        });
        
        this.mediaRecorder.stop();
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
        }
      })
    };
  }
}

let Mp3Recorder = null;

const initRecorder = async () => {
  if (!Mp3Recorder) {
    try {
      Mp3Recorder = new NativeMicRecorder();
    } catch (error) {
      console.error("Failed to initialize recorder:", error);
      return null;
    }
  }
  return Mp3Recorder;
};

const useStyles = makeStyles(theme => ({
  mainWrapper: {
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },

  newMessageBox: {
    background: "#eee",
    width: "100%",
    display: "flex",
    padding: "7px",
    alignItems: "center",
  },

  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    background: "#fff",
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
    alignItems: "center", // Alinear iconos verticalmente
  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    "& textarea": {
      color: "#1a1a2e !important",
      backgroundColor: "#fff !important"
    }
  },

  sendMessageIcons: {
    color: "grey",
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#eee",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  "@keyframes blink": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0 },
    "100%": { opacity: 1 }
  },
  blinkingDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: "#f15c6d",
    animation: "$blink 1.5s infinite"
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "50px",
    background: "#ffffff",
    padding: "2px",
    border: "1px solid #CCC",
    left: 0,
    width: "100%",
    "& li": {
      listStyle: "none",
      "& a": {
        display: "block",
        padding: "8px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxHeight: "32px",
        "&:hover": {
          background: "#F1F1F1",
          cursor: "pointer",
        },
      },
    },
  },
}));

const MessageInput = ({ ticketStatus, isAiChat, ticket }) => {
  const classes = useStyles();
  const { ticketId } = useParams();

  const [medias, setMedias] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  
  // [ZONA BLINDADA - FASE: Typeless Auto-Enhance & Dictation]
  const [isDictating, setIsDictating] = useState(false);
  const [recognition, setRecognition] = useState(null);

  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);

  // Evaluamos si el whatsapp asignado al ticket está conectado
  // Si ticket o ticket.whatsapp no existen aún (cargando), asumimos true para no bloquear sin razón
  // Se relaja la validación de estado estricto "CONNECTED" para evitar bloqueos en falso de UI
  const isConnectionOnline = !ticket || !ticket.whatsapp || ticket.whatsapp.status !== "DISCONNECTED";
  const disabledInput = isAiChat || recording || loading || ticketStatus !== "open" || !isConnectionOnline;

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      const recog = new SpeechRecognition();
      recog.continuous = true;
      recog.interimResults = true;
      recog.lang = 'es-ES';

      recog.onresult = (event) => {
        let finalTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            finalTranscript += event.results[i][0].transcript;
          }
        }
        if (finalTranscript) {
          setInputMessage((prev) => (prev + " " + finalTranscript).trim());
        }
      };

      recog.onerror = (event) => {
        console.error("Speech recognition error", event.error);
        setIsDictating(false);
      };

      recog.onend = () => {
        setIsDictating(false);
      };

      setRecognition(recog);
    }
  }, []);

  const toggleDictation = () => {
    if (!recognition) {
      toast.error("Tu navegador no soporta dictado por voz.");
      return;
    }
    if (isDictating) {
      recognition.stop();
      setIsDictating(false);
    } else {
      recognition.start();
      setIsDictating(true);
    }
  };

  useEffect(() => {
    inputRef.current.focus();
  }, [replyingMessage]);

  useEffect(() => {
    inputRef.current.focus();
    return () => {
      setInputMessage("");
      setShowEmoji(false);
      setMedias([]);
      setReplyingMessage(null);
    };
  }, [ticketId, setReplyingMessage]);

  const handleChangeInput = e => {
    setInputMessage(e.target.value);
    handleLoadQuickAnswer(e.target.value);
  };

  const handleQuickAnswersClick = value => {
    setInputMessage(value);
    setTypeBar(false);
  };

  const handleAddEmoji = e => {
    let emoji = e.native;
    setInputMessage(prevState => prevState + emoji);
  };

  const handleChangeMedias = e => {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    setMedias(selectedMedias);
  };

  const handleInputPaste = e => {
    if (e.clipboardData.files[0]) {
      setMedias([e.clipboardData.files[0]]);
    }
  };

  const handleUploadMedia = async (caption = "") => {
    setLoading(true);

    let finalCaption = caption;

    const formData = new FormData();
    formData.append("fromMe", true);
    medias.forEach(media => {
      formData.append("medias", media);
      if (finalCaption) {
        formData.append("body", finalCaption);
      }
    });

    try {
      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMedias([]);
    if (caption) setInputMessage("");
  };

  const handleSendMessage = async () => {
    if (inputMessage.trim() === "") return;
    setLoading(true);

    let finalBody = inputMessage.trim();
    try {
      const { data } = await api.post("/gemini/enhance", { 
        text: finalBody, 
        type: 'improvement' 
      });
      if (data && data.text) {
        finalBody = data.text;
      }
    } catch (err) {
      console.error("Error enhancing text:", err);
    }

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: finalBody,
      quotedMsg: replyingMessage,
    };
    try {
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      const recorder = await initRecorder();
      if (!recorder) {
        throw new Error("Recorder not available");
      }
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleLoadQuickAnswer = async value => {
    if (value && value.indexOf("/") === 0) {
      try {
        const { data } = await api.get("/quickAnswers/", {
          params: { searchParam: inputMessage.substring(1) },
        });
        setQuickAnswer(data.quickAnswers);
        if (data.quickAnswers.length > 0) {
          setTypeBar(true);
        } else {
          setTypeBar(false);
        }
      } catch (err) {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
  };

  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const recorder = await initRecorder();
      if (!recorder) {
        throw new Error("Recorder not available");
      }
      const [, blob] = await recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = `${new Date().getTime()}.ogg`;
      formData.append("medias", blob, filename);
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setRecording(false);
    setLoading(false);
  };

  const handleCancelAudio = async () => {
    try {
      const recorder = await initRecorder();
      if (recorder) {
        await recorder.stop().getMp3();
      }
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = event => {
    setAnchorEl(null);
  };

  const renderReplyingMessage = message => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.contact?.name}
              </span>
            )}
            {message.body}
            <Tooltip title="Dictado por voz">
              <IconButton
                aria-label="dictate-text"
                component="span"
                disabled={disabledInput}
                onClick={toggleDictation}
                style={{ padding: 8 }}
              >
                <RecordVoiceOver style={{ fontSize: 20, color: isDictating ? '#f15c6d' : (disabledInput ? 'grey' : '#7d3c98') }} />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading || ticketStatus !== "open"}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  if (medias.length > 0) {
    const isImage = medias[0].type.startsWith("image/");
    const previewUrl = isImage ? URL.createObjectURL(medias[0]) : null;

    return (
      <Dialog open={true} onClose={() => setMedias([])} maxWidth="md" fullWidth PaperProps={{ style: { backgroundColor: '#1a1a2e' } }}>
        <DialogTitle style={{ color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Vista previa
          <IconButton onClick={() => setMedias([])} style={{ color: '#fff' }}>
            <ClearIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', backgroundColor: '#111b21', padding: 20 }}>
          {isImage ? (
            <img src={previewUrl} alt="Preview" style={{ maxHeight: '60vh', maxWidth: '100%', objectFit: 'contain' }} />
          ) : (
            <div style={{ color: '#fff', textAlign: 'center' }}>
              <AttachFileIcon style={{ fontSize: 60, marginBottom: 10 }} />
              <Typography variant="h6">{medias[0].name}</Typography>
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ backgroundColor: '#202c33', padding: '15px 20px', display: 'flex', gap: 10 }}>
          <InputBase
            placeholder="Escribe un mensaje"
            value={inputMessage}
            onChange={handleChangeInput}
            onKeyPress={e => {
              if (loading || e.shiftKey) return;
              if (e.key === "Enter") handleUploadMedia(inputMessage);
            }}
            fullWidth
            style={{ backgroundColor: '#2a3942', color: '#d1d7db', padding: '10px 15px', borderRadius: 8 }}
          />
          <IconButton
            onClick={() => handleUploadMedia(inputMessage)}
            disabled={loading}
            style={{ backgroundColor: '#00a884', color: '#fff', padding: 12 }}
          >
            {loading ? <CircularProgress size={24} style={{ color: '#fff' }} /> : <SendIcon />}
          </IconButton>
        </DialogActions>
      </Dialog>
    );
  } else {
    return (
      <>
      <Paper square elevation={0} className={classes.mainWrapper}>
        {replyingMessage && renderReplyingMessage(replyingMessage)}
        <div className={classes.newMessageBox}>
          {recording ? (
            <div className={classes.recorderWrapper} style={{ flex: 1, justifyContent: 'space-between', backgroundColor: '#202c33', borderRadius: 20, padding: '5px 15px', alignItems: 'center' }}>
              <IconButton
                aria-label="cancelRecording"
                component="span"
                disabled={loading}
                onClick={handleCancelAudio}
                style={{ color: '#8696a0', padding: 8 }}
              >
                <DeleteIcon style={{ fontSize: 20 }} />
              </IconButton>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div className={classes.blinkingDot}></div>
                {loading ? (
                  <CircularProgress size={20} style={{ color: '#00a884' }} />
                ) : (
                  <RecordingTimer />
                )}
              </div>

              <IconButton
                aria-label="sendRecordedAudio"
                component="span"
                onClick={handleUploadAudio}
                disabled={loading}
                style={{ backgroundColor: '#00a884', color: '#fff', padding: 8 }}
              >
                <SendIcon style={{ fontSize: 18 }} />
              </IconButton>
            </div>
          ) : (
            <>
              <Hidden only={["sm", "xs"]}>
                <IconButton
                  aria-label="emojiPicker"
                  component="span"
                  disabled={disabledInput}
                  onClick={e => setShowEmoji(prevState => !prevState)}
                >
                  <MoodIcon className={classes.sendMessageIcons} />
                </IconButton>
                {showEmoji ? (
                  <div className={classes.emojiBox}>
                    <ClickAwayListener onClickAway={e => setShowEmoji(false)}>
                      <Picker
                        perLine={16}
                        showPreview={false}
                        showSkinTones={false}
                        onSelect={handleAddEmoji}
                      />
                    </ClickAwayListener>
                  </div>
                ) : null}

                <input
                  multiple
                  type="file"
                  id="upload-button"
                  disabled={disabledInput}
                  className={classes.uploadInput}
                  onChange={handleChangeMedias}
                />
                <label htmlFor="upload-button">
                  <IconButton
                    aria-label="upload"
                    component="span"
                    disabled={disabledInput}
                  >
                    <AttachFileIcon className={classes.sendMessageIcons} />
                  </IconButton>
                </label>
              </Hidden>
              <Hidden only={["md", "lg", "xl"]}>
                <IconButton
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleOpenMenuClick}
                >
                  <MoreVert></MoreVert>
                </IconButton>
                <Menu
                  id="simple-menu"
                  keepMounted
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuItemClick}
                >
                  <MenuItem onClick={handleMenuItemClick}>
                    <IconButton
                      aria-label="emojiPicker"
                      component="span"
                      disabled={disabledInput}
                      onClick={e => setShowEmoji(prevState => !prevState)}
                    >
                      <MoodIcon className={classes.sendMessageIcons} />
                    </IconButton>
                  </MenuItem>
                  <MenuItem onClick={handleMenuItemClick}>
                    <input
                      multiple
                      type="file"
                      id="upload-button"
                      disabled={disabledInput}
                      className={classes.uploadInput}
                      onChange={handleChangeMedias}
                    />
                    <label htmlFor="upload-button">
                      <IconButton
                        aria-label="upload"
                        component="span"
                        disabled={disabledInput}
                      >
                        <AttachFileIcon className={classes.sendMessageIcons} />
                      </IconButton>
                    </label>
                  </MenuItem>
                </Menu>
              </Hidden>
              <div className={classes.messageInputWrapper}>
                <InputBase
                  inputRef={input => {
                    input && input.focus();
                    input && (inputRef.current = input);
                  }}
                  className={classes.messageInput}
                  placeholder={
                    !isConnectionOnline 
                      ? "Conexión de WhatsApp fuera de línea." 
                      : isAiChat 
                      ? "Atendido por IA. Toma el chat para responder." 
                      : ticketStatus === "open"
                      ? i18n.t("messagesInput.placeholderOpen")
                      : i18n.t("messagesInput.placeholderClosed")
                  }
                  multiline
                  maxRows={5}
                  value={inputMessage}
                  onChange={handleChangeInput}
                  disabled={disabledInput}
                  onPaste={e => {
                    ticketStatus === "open" && !isAiChat && isConnectionOnline && handleInputPaste(e);
                  }}
                  onKeyPress={e => {
                    if (loading) return;
                    // Se ha eliminado la acción de enviar con "Enter".
                    // Ahora "Enter" solo creará un salto de línea natural.
                  }}
                />
                
                <Tooltip title="Dictado por voz">
                  <IconButton
                    aria-label="dictate-text"
                    component="span"
                    disabled={disabledInput}
                    onClick={toggleDictation}
                    style={{ padding: 8 }}
                  >
                    <RecordVoiceOver style={{ fontSize: 20, color: isDictating ? '#f15c6d' : (disabledInput ? 'grey' : '#7d3c98') }} />
                  </IconButton>
                </Tooltip>

                {typeBar ? (
                  <ul className={classes.messageQuickAnswersWrapper}>
                    {quickAnswers.map((value, index) => {
                      return (
                        <li
                          className={classes.messageQuickAnswersWrapperItem}
                          key={index}
                        >
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a onClick={() => handleQuickAnswersClick(value.message)}>
                            {`${value.shortcut} - ${value.message}`}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div></div>
                )}
              </div>
              {inputMessage ? (
                <IconButton
                  aria-label="sendMessage"
                  component="span"
                  onClick={handleSendMessage}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} style={{ color: '#00a884' }} />
                  ) : (
                    <SendIcon className={classes.sendMessageIcons} />
                  )}
                </IconButton>
              ) : (
                <IconButton
                  aria-label="showRecorder"
                  component="span"
                  disabled={disabledInput}
                  onClick={handleStartRecording}
                >
                  <MicIcon className={classes.sendMessageIcons} />
                </IconButton>
              )}
            </>
          )}
        </div>
      </Paper>
      </>
    );
  }
};

export default MessageInput;
